import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import EventPanel from "@/ml-exports/components/review/event-panel";

/* ═══════════════════════════════════════════════════════════════════
 * EVENT DETAIL PAGE
 *
 * /machine/event/:uuid → a single event, addressable by its own URL.
 *
 * Thin wrapper: hands the event UUID straight to EventPanel, which
 * resolves the surrounding truck-cycle (event rail, KPIs, time
 * breakdown) when one exists and renders the event on its own when it
 * does not. Related alerts, mini-map and evidence come from the same
 * event detail, so nothing extra is needed here.
 *
 * This is the canonical destination for an event link even when the
 * truck-cycle id is unknown — the alert cross-links point here.
 * ═══════════════════════════════════════════════════════════════════ */

const EventDetailPage = () => {
  const { t } = useTranslation("machines");
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();

  if (!uuid) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-3 bg-background">
        <div className="p-4 rounded-full bg-muted">
          <AlertTriangle className="h-8 w-8 text-muted-foreground" />
        </div>
        <p className="text-sm text-muted-foreground">{t("eventDetail.noEvent")}</p>
        <button
          onClick={() => navigate(-1)}
          className="text-xs text-primary underline underline-offset-4"
        >
          {t("actions.goBack")}
        </button>
      </div>
    );
  }

  return (
    <EventPanel
      eventUuid={uuid}
      onClose={() => navigate(-1)}
      onOpenInDetail={() => {}}
    />
  );
};

export default EventDetailPage;
